// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  CustomFieldInputPayload,
  CustomFieldInputPayloadFromJSON,
  CustomFieldInputPayloadToJSON,
} from "./";

/**
 *
 * @export
 * @interface TestPlanPayload
 */
export interface TestPlanPayload {
  /**
   *
   * @type {number}
   * @memberof TestPlanPayload
   */
  id?: number;
  /**
   *
   * @type {boolean}
   * @memberof TestPlanPayload
   */
  archived?: boolean;
  /**
   *
   * @type {string}
   * @memberof TestPlanPayload
   */
  title: string;
  /**
   *
   * @type {number}
   * @memberof TestPlanPayload
   */
  priority: TestPlanPayloadPriorityEnum;
  /**
   * 0 = Draft; 1 = Ready to execute; 2 = Finish; 3 = Finished (with failures);
   * @type {number}
   * @memberof TestPlanPayload
   */
  status: TestPlanPayloadStatusEnum;
  /**
   *
   * @type {number}
   * @memberof TestPlanPayload
   */
  testPlanFolder: number;
  /**
   *
   * @type {string}
   * @memberof TestPlanPayload
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof TestPlanPayload
   */
  startDate?: string;
  /**
   *
   * @type {string}
   * @memberof TestPlanPayload
   */
  endDate?: string;
  /**
   *
   * @type {number}
   * @memberof TestPlanPayload
   */
  project: number;
  /**
   * Release ID to associate this test plan with (optional). Omit this property entirely and the release of the linked build is filled in automatically; anything sent here stands as sent, including null for \"no release\", even when the build belongs to another release (TCV-6787)
   * @type {number}
   * @memberof TestPlanPayload
   */
  release?: number;
  /**
   * Build ID whose software version this test plan's results are traceable to (optional; send null to unlink) (TCV-6722)
   * @type {number}
   * @memberof TestPlanPayload
   */
  build?: number;
  /**
   * Array of custom fields
   * @type {Array<CustomFieldInputPayload>}
   * @memberof TestPlanPayload
   */
  customFields?: Array<CustomFieldInputPayload>;
}

export function TestPlanPayloadFromJSON(json: any): TestPlanPayload {
  return {
    id: !exists(json, "id") ? undefined : json["id"],
    archived: !exists(json, "archived") ? undefined : json["archived"],
    title: json["title"],
    priority: json["priority"],
    status: json["status"],
    testPlanFolder: json["test_plan_folder"],
    description: !exists(json, "description") ? undefined : json["description"],
    startDate: !exists(json, "start_date") ? undefined : json["start_date"],
    endDate: !exists(json, "end_date") ? undefined : json["end_date"],
    project: json["project"],
    release: !exists(json, "release") ? undefined : json["release"],
    build: !exists(json, "build") ? undefined : json["build"],
    customFields: !exists(json, "custom_fields")
      ? undefined
      : (json["custom_fields"] as Array<any>).map(
          CustomFieldInputPayloadFromJSON
        ),
  };
}

export function TestPlanPayloadToJSON(value?: TestPlanPayload): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    archived: value.archived,
    title: value.title,
    priority: value.priority,
    status: value.status,
    test_plan_folder: value.testPlanFolder,
    description: value.description,
    start_date: value.startDate,
    end_date: value.endDate,
    project: value.project,
    release: value.release,
    build: value.build,
    custom_fields:
      value.customFields === undefined
        ? undefined
        : (value.customFields as Array<any>).map(CustomFieldInputPayloadToJSON),
  };
}

/**
 * @export
 * @enum {string}
 */
export enum TestPlanPayloadPriorityEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
}
/**
 * @export
 * @enum {string}
 */
export enum TestPlanPayloadStatusEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
  NUMBER_3 = 3,
}
